import React from 'react';

// Import Css file
import './App.css';
import Router from './Router';


const App = () => {
  return(
    <React.Fragment>
      <Router />
    </React.Fragment>
  )
};

export default App;